module.exports = __webpack_public_path__ + "img/duration-icon.527302e8.svg";